import React from "react";

const FlightboardPage = () => {
  return (
    <div className="flex justify-between">
      <p>FlightboardPage</p>
      <p>FlightboardPage</p>
    </div>
  );
};

export default FlightboardPage;
